/* global Vue */

export default {
  name: 'InterestGroup',
  template: `
<fieldset>
  <legend v-text="title"></legend>
  <p v-if="textUpper" class="small-text" v-text="textUpper"></p>
  <slot name="header"></slot>

  <label v-for="(item, index) in items" :key="item.key" class="label-checkbox no-margin-bottom">
    <input
      v-if="Array.isArray(selectedItems)"
      type="checkbox"
      :id="item.key"
      :name="item.key"
      :value="item.key"
      v-model="selectedItems">
    <input
      v-else
      type="checkbox"
      :id="item.key"
      :name="item.key"
      :value="item.key"
      v-model="selectedItems[item.key]">
    <span v-text="item.title"></span>
  </label>

  <input v-if="allergiesBool" v-model="allergiesText" type="text" :placeholder="$t('preferencesTab.typeHere')">

  <p v-if="textLower" class="no-margin-bottom small-text" v-text="textLower"></p>
  <slot name="footer"></slot>
</fieldset>
  `,
  props: {
    items: Array,
    title: String,
    allergiesBool: Boolean,
    allergiesText: String,
    selectedItems: Array || Object,
  },
  emits: ['updateItems', 'updateAllergiesText'],
  setup: (props, { emit }) => {
    const { selectedItems, allergiesText } = Vue.toRefs(props)

    Vue.watch(selectedItems, (newValue) => {
      emit('updateItems', newValue)
    }, { deep: typeof selectedItems.value === 'object' })

    Vue.watch(allergiesText, (newValue) => {
      emit('updateAllergiesText', newValue)
    })

    return {
      selectedItems,
      allergiesText,
    }
  },
}
